export enum AnalyticsEvent {
  UpgradeContractRequestViewed = 'upgradeContractRequestViewed',
  UpgradeContractRequested = 'upgradeContractRequested',
  UpgradeContractRequestConfirmation = 'upgradeContractRequestConfirmation',
}
